import { useState, useEffect } from 'react';
import { Container, Stack, Typography, Alert, LinearProgress, Pagination,  } from "@mui/material";
import Page from "../../components/Page";
import AlertTable from './AlertTable';
import { alertList} from '../../config/services/alert';
import Controls from '../../components/controls/Controls';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';


export default function AlertList() {
    const [reportsList, setReportsList] = useState([])
    const [flag, setFlag] = useState(false)
    const [loading, setLoading] = useState(false)
    const [pageNo, setPagination] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [totalCount, setTotalCount] = useState(0)
    const navigate = useNavigate()

    let totalPages = Math.ceil(totalCount / itemsPerPage);

    const handlePagination = (e, pageNumber) => {
        setPagination(pageNumber)
    }


    const getAllAlerts = async () => {
        try {
            setLoading(true)
            const list = await alertList({pageNo: (pageNo-1), count:itemsPerPage})
            setReportsList(list?.result?.data)
            setTotalCount(list?.result?.totalAlerts)
            setLoading(false)
        } catch (error) {
            console.log('Error while getting alerts: ', error);
        }
    }

    const handleNavigate = () => {
        navigate('/addAlert')
    }
    
    useEffect(() => {
        getAllAlerts()
  
      }, [flag, pageNo])

    return (
        <>
            <Page title="Extramarks | AlertList ">
                <Container className='table_max_width'>
                    <Stack direction="row" alignContent="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4">
                            Scheduled Report List
                        </Typography>
                        <Controls.Button
                            text="Add Alert"
                            variant="contained"
                            startIcon={<AddIcon />}
                            onClick={() => handleNavigate()}
                            size='medium'
                        />
                    </Stack>
                    
                    {(reportsList?.length>0 && !loading) ? <AlertTable pageNo={pageNo} itemsPerPage={itemsPerPage} reportsList={reportsList} setFlag={setFlag} flag={flag}/> :
                        (loading? <LinearProgress color='primary' />:
                        <Alert severity="error">No Content Available!</Alert>)}
                </Container>

                <div className='center cm_pagination'>
                    <Pagination count={totalPages} variant="outlined" color="primary" onChange={handlePagination} page={pageNo} />
                </div>
            </Page>
        </>
    )
}
